import React from 'react'
import './OEIPopover.css'
import OEIEditText from './OEIEditText';
import {getEmailList} from './OEIUtils'
import AddNewEmailModel from './AddNewEmailModel';
import { EMPTY } from './Constants';
export default function EditNotificationPopover(props) {
    var arr=[];
  
const removeEmail=(type,email)=>{
    if(type==='all'){
    var list = getEmailList(props.editData.allEmailAddresses);
    const index = list.indexOf(email);
if (index > -1) { 
    list.splice(index, 1);
}
props.setEditData({...props.editData, allEmailAddresses:list.toString()})
    }else{
        var list = getEmailList(props.editData.emailAddresses);
    const index = list.indexOf(email);
if (index > -1) { 
    list.splice(index, 1);
}
props.setEditData({...props.editData, emailAddresses:list.toString()})
    }
}
    return (
        <>
<div className="oe-form-field">
  <label className="oe-form-field__title" >{props.name}</label>
  <select className="oe-form-field__control" value={props.eventType}>
            <option value={props.eventType}>{props.eventType==='Event Updated'?'Event Edited':props.eventType}</option>  
  </select>
  { props.errors.error1!==EMPTY?
 <div className="oe-form-field__error">{props.errors.error1}</div>
 :EMPTY
}
  </div>     
  <OEIEditText  type='edit' editData={props.editData} setNewData={props.setNewData}email={props.email}cancelEmailAdding={props.cancelEmailAdding}emailId={props.emailId}setEmailid={props.setEmailid}error={props.error}setError={props.setError}toggeleChecked={props.toggeleChecked}onChangeToggle={props.onChangeToggle}addEmail={props.addEmail}newData={props.newData}removeEmail={removeEmail}error2={props.errors.error2}setErrors={props.setErrors}setEmail={props.setEmail}emailList={getEmailList(props.emails)} allEmails={getEmailList(props.editData.allEmailAddresses)} selectedValue={props.editData.notificationType}></OEIEditText> 
        </>
    )
}
